
// import React, { useState, useEffect } from "react";
// import apiService from "../../Common/Configurations/APIService";
// import config from "../../Common/Configurations/APIConfig";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import moment from "moment";
// import ReportTabs from "../AllTabs/ReportTabs";
// import Header from "../../Common/Layout/Header";
// import GstPaymentModal from "./GstPaymentModal";

// const GstReport = () => {
//   const { user } = useAuth();
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
//   const [toDate, setFromTo] = useState(moment().format("YYYY-MM-DD"));
//   const [showPaymentModal, setShowPaymentModal] = useState(false);

//   const fetchGstReport = async () => {
//     setLoading(true);
//     try {
//       const res = await apiService.getAll(`${config.GETGSTREPORT}/${user.cid}?fromDate=${fromDate}&toDate=${toDate}`);
//       setData(res);
//     } catch (error) {
//       console.error("Error fetching GST report", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { if (user?.cid) fetchGstReport(); }, [user?.cid]);

//   const formatCurr = (val) => Number(val).toLocaleString("en-IN", { style: "currency", currency: "INR" });

//   return (
//     <div className="gst-main-wrapper">
//       <Header User={user} />
//       <div className="p-2">
//         <ReportTabs pageName="GSTREPORT" />
//       </div>

//       <div className="report-container">
        
//         {/* Header Section */}
//         <div className="report-header">
//           <div>
//             <h2 className="report-title">GST / Tax Report</h2>
//             <p className="company-id">GST Summary & Liability Statement</p>
//           </div>

//           <div className="filter-bar">
//             <div className="date-input">
//               <span>From Date</span>
//               <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
//             </div>
//             <div className="date-input">
//               <span>To Date</span>
//               <input type="date" value={toDate} onChange={e => setFromTo(e.target.value)} />
//             </div>
//             <button className="search-button" onClick={fetchGstReport} disabled={loading}>
//               {loading ? "Generating..." : "UPDATE REPORT"}
//             </button>
//           </div>
//         </div>

//         {data && (
//           <div className="report-body">
            
//             {/* Summary Cards */}
//             <div className="summary-section">
//               {/* Card 1: Output Tax */}
//               <div className="summary-card blue-card">
//                 <div className="card-label">Output Tax (Collected)</div>
//                 <div className="card-value text-blue">{formatCurr(data.totalOutputTax)}</div>
//                 <div className="card-sub">Sales & Outwards</div>
//               </div>

//               {/* Card 2: Input Tax */}
//               <div className="summary-card red-card">
//                 <div className="card-label">Input Tax (Paid/ITC)</div>
//                 <div className="card-value text-red">{formatCurr(data.totalInputTax)}</div>
//                 <div className="card-sub">Purchases & Inwards</div>
//               </div>

//               {/* Card 3: Net Payable */}
//               <div className="summary-card green-card">
//                 <div className="card-label">Net GST Payable</div>
//                 <div className="card-value text-green">{formatCurr(data.netGstPayable)}</div>
//                 <div className="card-sub">Total Liability</div>
//                 {data.netGstPayable > 0 && (
//                   <button 
//                     className="settle-btn" 
//                     onClick={() => setShowPaymentModal(true)}
//                   >
//                     SETTLE LIABILITY
//                   </button>
//                 )}
//               </div>
//             </div>

//             {/* Divider */}
//             <div className="section-divider">
//               <span>Detailed Tax Breakdown</span>
//             </div>

//             {/* Table */}
//             <div className="table-wrapper">
//               <table className="gst-table">
//                 <thead>
//                   <tr>
//                     <th>Date</th>
//                     <th>Invoice #</th>
//                     <th>Party Name</th>
//                     <th className="text-center">Type</th>
//                     <th className="text-right">Tax Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.taxLines.map((line, i) => (
//                     <tr key={i}>
//                       <td>{moment(line.date).format("DD-MM-YYYY")}</td>
//                       <td className="font-medium">{line.invoiceNumber}</td>
//                       <td>{line.partyName}</td>
//                       <td className="text-center">
//                         <span className={`status-badge ${line.type === "Output" ? "badge-output" : "badge-input"}`}>
//                           {line.type}
//                         </span>
//                       </td>
//                       <td className="text-right font-bold">
//                         {formatCurr(line.taxAmount)}
//                       </td>
//                     </tr>
//                   ))}
//                   {data.taxLines.length === 0 && (
//                      <tr><td colSpan="5" className="text-center p-4">No records found for this period</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}
//       </div>
//        {showPaymentModal && (
//         <GstPaymentModal 
//           companyId={user.cid}
//           pendingAmount={data.netGstPayable}
//           onClose={() => setShowPaymentModal(false)}
//           onSuccess={fetchGstReport}
//         />
//       )}

//       <style jsx>{`
//         .gst-main-wrapper {
//           padding: 30px;
//           background-color: #f4f7f6;
//           min-height: 100vh;
//           font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//         }

//         /* --- CONTAINER & HEADER --- */
//         .report-container {
//           background: #ffffff;
//           border-radius: 8px;
//           box-shadow: 0 4px 15px rgba(0,0,0,0.08);
//           overflow: hidden;
//           border-top: 5px solid #0056b3;
//           max-width: 1100px;
//           margin: 0 auto;
//         }
//         .report-header {
//           background-color: #0056b3;
//           color: white;
//           padding: 20px 30px;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }
//         .report-title { margin: 0; font-size: 22px; font-weight: 600; letter-spacing: 0.5px; color: #fff; }
//         .company-id { margin: 0; font-size: 13px; opacity: 0.85; margin-top: 4px; }

//         /* --- FILTERS --- */
//         .filter-bar { display: flex; gap: 15px; align-items: flex-end; }
//         .date-input { display: flex; flex-direction: column; }
//         .date-input span { font-size: 11px; font-weight: 600; text-transform: uppercase; margin-bottom: 4px; color: #daeaff; }
//         .date-input input { 
//           border-radius: 4px; border: none; padding: 8px 12px; font-size: 13px; color: #333; outline: none; 
//           background: #fff; box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//         }
//         .search-button { 
//           padding: 8px 20px; 
//           background: #ffffff; 
//           color: #0056b3; 
//           border: none; 
//           border-radius: 4px; 
//           font-weight: 700; 
//           cursor: pointer; 
//           transition: 0.2s;
//           font-size: 12px;
//           letter-spacing: 0.5px;
//           height: 35px;
//         }
//         .search-button:hover { background: #e6eef7; transform: translateY(-1px); }

//         /* --- BODY --- */
//         .report-body { padding: 30px; color: #333; }

//         /* --- SUMMARY CARDS --- */
//         .summary-section {
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 20px;
//           margin-bottom: 30px;
//         }
//         .summary-card {
//           padding: 20px;
//           border-radius: 8px;
//           background: #fff;
//           border: 1px solid #e1e4e8;
//           text-align: center;
//           transition: transform 0.2s;
//         }
//         .summary-card:hover { transform: translateY(-3px); box-shadow: 0 5px 15px rgba(0,0,0,0.05); }
        
//         .blue-card { border-top: 4px solid #0056b3; }
//         .red-card { border-top: 4px solid #dc3545; }
//         .green-card { border-top: 4px solid #28a745; background: #f0fff4; border-color: #c6f6d5; }

//         .card-label { font-size: 12px; font-weight: 600; text-transform: uppercase; color: #666; letter-spacing: 1px; margin-bottom: 10px; }
//         .card-value { font-size: 24px; font-weight: 700; margin-bottom: 5px; }
//         .card-sub { font-size: 11px; color: #999; }

//         .text-blue { color: #0056b3; }
//         .text-red { color: #dc3545; }
//         .text-green { color: #28a745; }

//         /* --- DIVIDER --- */
//         .section-divider {
//           display: flex; 
//           align-items: center; 
//           margin: 30px 0 20px 0;
//           color: #888;
//           font-size: 12px;
//           text-transform: uppercase;
//           font-weight: 600;
//         }
//         .section-divider::before, .section-divider::after {
//           content: ''; flex: 1; height: 1px; background: #eee;
//         }
//         .section-divider span { padding: 0 15px; }

//         /* --- TABLE --- */
//         .table-wrapper { border: 1px solid #eee; border-radius: 6px; overflow: hidden; }
//         .gst-table { width: 100%; border-collapse: collapse; }
        
//         .gst-table th { 
//           background: #f8f9fa;
//           text-align: left; 
//           padding: 15px; 
//           color: #555; 
//           font-size: 12px; 
//           font-weight: 700;
//           text-transform: uppercase; 
//           border-bottom: 2px solid #eee; 
//         }
        
//         .gst-table td { 
//           padding: 12px 15px; 
//           border-bottom: 1px solid #f2f2f2; 
//           font-size: 14px;
//           color: #444;
//         }
//         .gst-table tr:hover { background-color: #fbfbfb; }

//         .text-right { text-align: right; }
//         .text-center { text-align: center; }
//         .font-medium { font-weight: 600; color: #333; }
//         .font-bold { font-weight: 700; color: #000; }

//         /* --- BADGES --- */
//         .status-badge {
//           padding: 4px 10px;
//           border-radius: 12px;
//           font-size: 11px;
//           font-weight: 600;
//           display: inline-block;
//           min-width: 70px;
//         }
//         .badge-output {
//           background-color: #e6f0ff;
//           color: #0056b3;
//           border: 1px solid #b8daff;
//         }
//         .badge-input {
//           background-color: #fff5f5;
//           color: #dc3545;
//           border: 1px solid #f5c6cb;
//         }
//            .settle-btn {
//           margin-top: 15px;
//           background: #28a745;
//           color: white;
//           border: none;
//           padding: 6px 12px;
//           border-radius: 4px;
//           font-size: 11px;
//           font-weight: bold;
//           cursor: pointer;
//           transition: 0.2s;
//         }
//         .settle-btn:hover { background: #218838; }

//         /* Responsive Adjustments */
//         @media (max-width: 768px) {
//           .summary-section { grid-template-columns: 1fr; }
//           .filter-bar { flex-wrap: wrap; }
//           .report-header { flex-direction: column; align-items: flex-start; gap: 15px; }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default GstReport;


import React, { useState, useEffect } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";
import ReportTabs from "../AllTabs/ReportTabs";
import Header from "../../Common/Layout/Header";
import GstPaymentModal from "./GstPaymentModal";

const GstReport = () => {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [toDate, setFromTo] = useState(moment().format("YYYY-MM-DD"));
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const fetchGstReport = async () => {
    setLoading(true);
    try {
      const res = await apiService.getAll(`${config.GETGSTREPORT}/${user.cid}?fromDate=${fromDate}&toDate=${toDate}`);
      setData(res);
    } catch (error) {
      console.error("Error fetching GST report", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { if (user?.cid) fetchGstReport(); }, [user?.cid]);

  const format = (val) => Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2 });

  return (
    <div id="layout-wrapper">
      <Header User={user} activeSection={"reports"}/>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card shadow-sm">
                
                {/* 1. TABS SECTION */}
                <div className="p-2">
                  <ReportTabs pageName="GSTREPORT" />
                </div>

                <div className="card-body p-0">
                  <div className="report-container">
                    
                    {/* Header & Filter Section with Blue Background */}
                    <div className="report-header">
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h2 className="report-title">GST / Tax Report</h2>
                          <p className="company-id">GST Summary & Liability Statement</p>
                        </div>
                      </div>

                      {/* Integrated Filter Bar */}
                      <div className="filter-bar no-print mt-3">
                        <div className="date-input">
                          <label>From Date</label>
                          <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
                        </div>
                        <div className="date-input">
                          <label>To Date</label>
                          <input type="date" value={toDate} onChange={e => setFromTo(e.target.value)} />
                        </div>
                        <button className="search-button" onClick={fetchGstReport} disabled={loading}>
                          {loading ? "Generating..." : "UPDATE REPORT"}
                        </button>
                      </div>
                    </div>

                    {data && (
                      <div className="report-body p-4">
                        
                        {/* Summary Section with Vibrant Cards */}
                        <div className="summary-section">
                          <div className="summary-card blue-card">
                            <div className="card-label">Output Tax (Collected)</div>
                            <div className="card-value text-blue">INR {format(data.totalOutputTax)}</div>
                            <div className="card-sub">Sales & Outwards</div>
                          </div>

                          <div className="summary-card red-card">
                            <div className="card-label">Input Tax (Paid/ITC)</div>
                            <div className="card-value text-red">INR {format(data.totalInputTax)}</div>
                            <div className="card-sub">Purchases & Inwards</div>
                          </div>

                          <div className="summary-card green-card">
                            <div className="card-label">Net GST Payable</div>
                            <div className="card-value text-green">INR {format(data.netGstPayable)}</div>
                            <div className="card-sub">Total Liability</div>
                            {data.netGstPayable > 0 && (
                              <button className="settle-btn" onClick={() => setShowPaymentModal(true)}>
                                SETTLE LIABILITY
                              </button>
                            )}
                          </div>
                        </div>

                        {/* Table Section */}
                        <div className="section-divider mt-4">
                          <span>Detailed Tax Breakdown</span>
                        </div>

                        <div className="table-responsive table-card">
                          <table className="gst-table table align-middle">
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th>Invoice #</th>
                                <th>Party Name</th>
                                <th className="text-center">Type</th>
                                <th className="text-end">Tax Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.taxLines.map((line, i) => (
                                <tr key={i}>
                                  <td>{moment(line.date).format("DD-MM-YYYY")}</td>
                                  <td className="fw-bold text-dark">{line.invoiceNumber}</td>
                                  <td>{line.partyName}</td>
                                  <td className="text-center">
                                    <span className={`status-badge ${line.type === "Output" ? "badge-output" : "badge-input"}`}>
                                      {line.type}
                                    </span>
                                  </td>
                                  <td className="text-end fw-bold">
                                    INR {format(line.taxAmount)}
                                  </td>
                                </tr>
                              ))}
                              {data.taxLines.length === 0 && (
                                 <tr><td colSpan="5" className="text-center p-5 text-muted">No tax records found for this period</td></tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {showPaymentModal && (
        <GstPaymentModal 
          companyId={user.cid}
          pendingAmount={data.netGstPayable}
          onClose={() => setShowPaymentModal(false)}
          onSuccess={fetchGstReport}
        />
      )}

      <style jsx>{`
        .report-container { background: white; border-radius: 8px; overflow: hidden; }
        .report-header { background-color: #0056b3; color: white; padding: 25px 30px; }
        .report-title { margin: 0; font-size: 24px; font-weight: 700; color: #fff; }
        .company-id { margin: 0; font-size: 13px; opacity: 0.9; margin-top: 5px; }

        /* Filter Bar inside Header */
        .filter-bar { background: rgba(255,255,255,0.15); padding: 15px; border-radius: 8px; display: flex; gap: 15px; align-items: flex-end; }
        .date-input { display: flex; flex-direction: column; }
        .date-input label { font-size: 11px; font-weight: 700; text-transform: uppercase; margin-bottom: 5px; color: #fff; }
        .date-input input { border-radius: 4px; border: none; padding: 8px 12px; font-size: 13px; color: #333; outline: none; background: #fff; }
        .search-button { padding: 9px 20px; background: #ffffff; color: #0056b3; border: none; border-radius: 4px; font-weight: 800; cursor: pointer; font-size: 12px; }

        /* Summary Section */
        .summary-section { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-top: 10px; }
        .summary-card { padding: 25px 20px; border-radius: 12px; background: #fff; border: 1px solid #eef2f6; text-align: center; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05); }
        
        .blue-card { border-top: 5px solid #0056b3; }
        .red-card { border-top: 5px solid #dc3545; }
        .green-card { border-top: 5px solid #28a745; background: #f0fff4; }

        .card-label { font-size: 11px; font-weight: 700; text-transform: uppercase; color: #64748b; margin-bottom: 8px; }
        .card-value { font-size: 26px; font-weight: 800; margin-bottom: 4px; }
        .card-sub { font-size: 11px; color: #94a3b8; font-weight: 500; }

        /* Color Locks */
        .text-blue { color: #0056b3 !important; }
        .text-red { color: #dc3545 !important; }
        .text-green { color: #28a745 !important; }

        /* Divider */
        .section-divider { display: flex; align-items: center; margin: 35px 0 20px 0; color: #94a3b8; font-size: 11px; text-transform: uppercase; font-weight: 700; letter-spacing: 1px; }
        .section-divider::before, .section-divider::after { content: ''; flex: 1; height: 1px; background: #e2e8f0; }
        .section-divider span { padding: 0 15px; }

        /* Table Styles */
        .gst-table th { background: #f8fafc; padding: 15px; color: #64748b; font-size: 11px; font-weight: 800; text-transform: uppercase; border-bottom: 2px solid #e2e8f0; }
        .gst-table td { padding: 15px; border-bottom: 1px solid #f1f5f9; font-size: 14px; color: #334155; }

        /* Badges */
        .status-badge { padding: 4px 12px; border-radius: 20px; font-size: 11px; font-weight: 700; display: inline-block; }
        .badge-output { background-color: #e0f2fe; color: #0369a1; }
        .badge-input { background-color: #fef2f2; color: #b91c1c; }

        .settle-btn { margin-top: 15px; background: #28a745; color: white; border: none; padding: 8px 18px; border-radius: 6px; font-size: 12px; font-weight: 800; cursor: pointer; transition: 0.2s; }
        .settle-btn:hover { background: #218838; transform: scale(1.05); }

        @media (max-width: 768px) { .summary-section { grid-template-columns: 1fr; } }
      `}</style>
    </div>
  );
};

export default GstReport;